import React from 'react';
import LogoLoop from './LogoLoop';

const clients = [
  { name: 'studio5Logo', logo: '/projects logos/studio5Logo.png' },
  { name: 'qm-logo', logo: '/projects logos/QM_logo_bw.svg' },
  { name: 'visit-qatar-logo', logo: '/projects logos/visit-qatar-logo.svg' },
    { name: 'QNCC logo', logo: '/projects logos/QNCC logo.svg' },
  { name: 'qstp-logo', logo: '/projects logos/qstp.png' },
  { name: 'Katara Art Center logo', logo: '/projects logos/Katara Art Center logo.png' },
  { name: 'riwaq-logo', logo: '/projects logos/riwaq logo.png' },
];

// Convert to the format the LogoLoop component expects
const imageLogos = clients.map(client => ({
  src: client.logo,
  alt: client.name,
}));

const ClientsSlider1 = () => {
  return (
    <div style={{ height: '200px', position: 'relative', overflow: 'hidden'}}>
      <LogoLoop
        logos={imageLogos} // Pass src + alt objects
        speed={60}
        direction="left"
        logoHeight={70}
        gap={80}
        pauseOnHover
        scaleOnHover
        fadeOut
        fadeOutColor="#000000ff"
        ariaLabel="Technology partners"
      />
    </div>
  );
};


export default ClientsSlider1;